import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Head hygiene: the static index.html tags and any prerendered/crawler-cache snapshot of a previous render
// are removed before React mounts, so react-helmet-async (components/Seo.jsx) is the only writer of SEO metadata.
document.head
  .querySelectorAll('title, meta[name="description"], meta[name="robots"], link[rel="canonical"], meta[property^="og:"], meta[name^="twitter:"], script[type="application/ld+json"]')
  .forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
